import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Segment, segmentType } from "../../types/slices/segmentType";
import { RootState } from "../store";

const initialState: segmentType =
{
    status: ApiStatus.FETCHED,
    segments: [],
    editSegment: {} as Segment,
    errorMessage: undefined,
    action: ''
}

const segmentSlice = createSlice({
    name: 'segmentSlice',
    initialState,
    reducers: {
        onFetchSegments (state, { payload }: { payload: Segment[]}) {
            state.status = ApiStatus.FETCHED
            state.segments = payload
            state.errorMessage = undefined
        },
        onSetEditSegment (state, { payload }: { payload: Segment }) {
            state.editSegment = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSegmentState = (state: RootState) => state.segmentSlice
export default segmentSlice.reducer

export const {
    onFetchSegments,
    onSetEditSegment,
    changeStatus,
    setAction,
} = segmentSlice.actions